import React, { useState } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_CLIENT } from "./queries";

import map from "lodash/map";
import find from "lodash/find";
import unset from "lodash/unset";
import head from "lodash/head";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import concat from "lodash/concat";
import includes from "lodash/includes";
import withSession from "./withSession";
import {
  ADD_CHALLENGE_TO_CLIENT,
  UPDATE_CHALLENGE,
  DELETE_CHALLENGE,
  IMAGE_UPLOAD,
  PUBLISH_CHALLENGE,
  SEND_NOTIFICATIONS,
  ADD_NOTIFICATION_TO_CLIENT,
  UPDATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  CHANGE_STORE_SIGNUP,
} from "./mutations";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { modules } from "constants/reactQuill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./Forms/SignUpWizard/datePicker.css";

const MAXSIZE = 100000000; //bytes
const FILETYPES = ["application/pdf", "image/*"];

const options = [
  { value: "everyone", label: "Everyone" },
  { value: "coaches", label: "Coaches" },
  { value: "challengeAll", label: "Challenge - Everyone" },
  { value: "challengeCoach", label: "Challenge - Coaches" },
];

function SignUpManager(props) {
  const [modal, setModal] = React.useState(false);

  const [title, setTitle] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [sendTo, setSendTo] = React.useState({
    value: "everyone",
    label: "Everyone",
  });
  const [selectedChallenge, setSelectedChallenge] = React.useState(null);
  const [frequency, setFrequency] = React.useState("none");
  const [time, setTime] = React.useState(8);
  const [date, setDate] = React.useState(null);
  const [showError, setShowError] = React.useState("");
  const [showErrorConfirm, setShowErrorConfirm] = React.useState("");

  const [editNotificationId, setEditNotificationId] = React.useState("");
  const [deleteNotificationId, setDeleteNotificationId] = React.useState("");

  const handleOpenEdit = (notification) => {
    setModal(true);
    setEditNotificationId(notification?._id);
    setTitle(notification?.title);
    setMessage(notification?.message);
    setSendTo(
      find(options, (option) => {
        return option.label === notification?.sendTo;
      })
    );
    if (notification?.filters?.challengeId)
      setSelectedChallenge(notification?.filters?.challengeId);
    setFrequency(notification?.frequency);
    setTime(notification?.time);
    setDate(notification?.date);
  };

  const handleOpenDelete = (notification) => {
    // setDeleteModal(true)
    setDeleteNotificationId(notification._id);
  };

  const handleCloseDelete = () => {
    // setDeleteModal(false)
    setDeleteNotificationId("");
  };

  const handleClose = () => {
    setModal(false);
    setEditNotificationId("");
    setDeleteNotificationId("");
    setTitle("");
    setMessage("");
    setSendTo({ value: "everyone", label: "Everyone" });
    setSelectedChallenge(null);
    setFrequency("none");
    setTime(8);
    setDate(null);
  };

  const [changeStoreSignup] = useMutation(CHANGE_STORE_SIGNUP);

  const handleChange = (event) => {
    console.log(event);
    changeStoreSignup({
      variables: {
        clientId: props.session.me.clientId,
        storeSignup: event.target.checked,
      },
    }).then(() => {});
  };

  return (
    <Query
      query={GET_CLIENT}
      variables={{
        name: props.session.me.clientName,
      }}
    >
      {({ loading, data, refetch }) => {
        if (loading) return "Loading...";
        const { getClient } = data;
        const { storeSignup } = getClient || {};

        return (
          <>
            <Container fluid>
              <Row>
                <Col md="12">
                  <h4 className="title">Sign up Manager</h4>
                </Col>
                <Col xs="12" style={{ marginTop: 25, textAlign: "right" }}>
                  <Form.Check.Label>
                    <Form.Check.Input
                      defaultChecked={storeSignup}
                      type="checkbox"
                      onClick={handleChange}
                    ></Form.Check.Input>
                    <span className="form-check-sign"></span>
                    Enable Store Sign Up
                  </Form.Check.Label>
                </Col>
              </Row>
            </Container>
          </>
        );
      }}
    </Query>
  );
}

export default withSession(SignUpManager);
